import { render, staticRenderFns } from "./wait-page.vue?vue&type=template&id=6fa824e3&scoped=true"
import script from "./wait-page.vue?vue&type=script&lang=js"
export * from "./wait-page.vue?vue&type=script&lang=js"
import style0 from "./wait-page.vue?vue&type=style&index=0&id=6fa824e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa824e3",
  null
  
)

export default component.exports